import { prefersReducedMotion } from '@theme/utilities';

// ponytail: home page + product.electric-golf-caddy + page.guide only (gated by the
// data-template CSS scope in base.css and the template check in
// snippets/scripts.liquid), add more templates to both places if needed.
// Reveals each section wrapper AND the individual gozo-* cards/headings/
// text blocks inside it, so scrolling triggers many small fades instead of
// one big one. Siblings under the same parent (e.g. a row of stat/tech/mode
// cards) get a short stagger, matching the reveal cascade described in the
// WordPress style teardown (section 13).
if (!prefersReducedMotion()) {
  const SELECTORS = [
    '#MainContent > .section-wrapper',
    'article[class*="gozo-grid-card-"]',
    'article[class*="gozo-stat-item-"]',
    'div[class*="gozo-faq-card-"]',
    'div[class*="gozo-video-card-"]',
    'div[class*="gozo-heading-"]',
    'div[class*="gozo-split-"]',
    'div[class*="gozo-video-banner-"]',
    'div[class*="gozo-compare-"]',
    '.group-block',
  ];

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('scroll-reveal--visible');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -12% 0px' }
  );

  const seen = new Set();
  const staggerCounts = new Map();

  SELECTORS.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => {
      // Skip nested duplicates matched by the same selector (e.g. a video
      // card's inner media/body divs also contain "gozo-video-card-").
      if (el.parentElement?.closest(selector)) return;
      if (seen.has(el)) return;
      if (el.getBoundingClientRect().top < window.innerHeight) return;

      seen.add(el);

      const step = staggerCounts.get(el.parentElement) ?? 0;
      staggerCounts.set(el.parentElement, step + 1);

      el.style.transitionDelay = `${Math.min(step, 4) * 80}ms`;
      el.classList.add('scroll-reveal');
      observer.observe(el);
    });
  });
}
